/* eslint @typescript-eslint/no-var-requires: "off" */
import { ConfigFeature, createBriqProvider, createBriqTheme } from '@briq/core'
import { disableReactDevTools } from '@fvilers/disable-react-devtools'
import 'antd/dist/reset.css'
import axios from 'axios'
import ReactDOM from 'react-dom'

import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import i18n, { availableLanguages, primaryLanguage } from './i18n'
import { icons, images } from './images'
import { routeComponentOverrideConfig } from './routes/routeOverrideConfig'
import routes from './routes/routes'
import * as serviceWorker from './serviceWorker'

if (process.env.NODE_ENV === 'production') {
  disableReactDevTools()
}

const configURL = '/app/config/config.json'

fetch(configURL)
  .then(response => response.json())
  .then(data => {
    if (!data.localeMap) {
      // eslint-disable-next-line
      console.error('You need to set localeMap in config.json')
      return
    }

    if (!data.googleRecaptchaSiteKey) {
      // eslint-disable-next-line no-console
      console.warn("googleRecaptchaSiteKey not set, some forms won't work properly")
    }

    const { BriqProvider, store } = createBriqProvider(createBriqTheme(), {
      axios,
      appConfig: {
        primaryLanguage,
        availableLanguages,
        routes,
        routesComponentConfig: routeComponentOverrideConfig
      },
      i18Next: i18n,
      gtmId: data.gtmId,
      icons,
      images
    })

    store.dispatch(
      ConfigFeature.ConfigActions.setJsonConfig({
        config: {
          googleRecaptchaSiteKey: data.googleRecaptchaSiteKey,
          viewHtmlIcon: data.viewHtmlIcon,
          officialDocumentsCountries: data.officialDocumentsCountries,
          countryCode: data.countryCode,
          pageSizes: data.pageSizes || {},
          localeMap: data.localeMap,
          registrationNumbers: data.registrationNumbers || [],
          publicUrl: data.publicUrl,
          completedReportStatus: data.completedReportStatus,
          gtmId: data.gtmId,
          pricesMode: data.pricesMode,
          primaryIdentifier: data.primaryIdentifier,
          domesticOfferingCountries: data.domesticOfferingCountries,
          redirectToCartOnItemAdded: data.redirectToCartOnItemAdded,
          orderProcessingTimeoutSec: data.orderProcessingTimeoutSec,
          officeEnabled: data.officeEnabled,
          import: data.import,
          maximumNumberOfSupportedItems: data.maximumNumberOfSupportedItems,
          localCountries: data.localCountries || []
        }
      })
    )

    ReactDOM.render(<BriqProvider />, document.getElementById('root'))

    // If you want your app to work offline and load faster, you can change
    // unregister() to register() below. Note this comes with some pitfalls.
    // Learn more about service workers: https://bit.ly/CRA-PWA
    serviceWorker.unregister()
  })
